import './index.less';



// WEBPACK FOOTER //
// ./ecology9/wea-tab/style/index.js